import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from "../../shared/shared.module";

import { Constants } from '../../shared/common/helper/constants';
import { AdminGuard } from '../services/admin-guard.service';
import { AdminService } from '../services/admin.service';

import { DepartmentReportsComponent } from '../../shared/common/components/department-reports/department-reports.component';
import { CustomReportsComponent } from '../../shared/common/components/custom-reports/custom-reports.component';
import { BacklogReportsComponent } from '../../shared/common/components/backlog-reports/backlog-reports.component';
import { TeamReportsComponent } from '../../shared/common/components/team-reports/team-reports.component';
import { TeamsReportsComponent } from '../../shared/common/components/teams-reports/teams-reports.component';
import { ReportsTableComponent } from '../../shared/common/components/reports-table/reports-table.component';

@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    SharedModule,
    RouterModule,
    NgbModule,
  ],
  declarations: [
    DepartmentReportsComponent,
    CustomReportsComponent,
    BacklogReportsComponent,
    TeamReportsComponent,
    TeamsReportsComponent,
    ReportsTableComponent
  ],
  providers: [
    Constants,
    AdminGuard,
    AdminService
  ],
})
export class ReportsModule { }
